import config from '../config';
import axios from 'axios';
import { DashboardStatistics } from '@/types/api/dashboard';

export const apiGetDashboardStatistics = async () => {
  return await axios.get<DashboardStatistics>(`${config.apiUrl}userapi/dashboard-statistics`);
};
